module.exports = __webpack_public_path__ + "img/dells.0680410e.jpg";